import axios from '@/lib/axios';

export interface HeroPlaylist {
  _id?: string;
  playlist: {
    _id: string;
    name: string;
    description?: string;
    artwork?: string;
    songs?: any[];
    totalDuration?: number;
  };
  order: number;
  title?: string | null;
  subtitle?: string | null;
  backgroundColor: string;
  active: boolean;
  startDate?: string | null;
  endDate?: string | null;
  targetCompanies: Array<{ _id: string; name: string }>;
  createdBy?: {
    _id: string;
    name: string;
    email: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateHeroPlaylistData {
  playlist: string; // Playlist ID
  title?: string;
  subtitle?: string;
  backgroundColor?: string;
  startDate?: string | null;
  endDate?: string | null;
  targetCompanies?: string[]; // Company IDs
}

export interface HeroCheckResult {
  isInHero: boolean;
  heroPlaylistId: string | null;
  heroPlaylist: HeroPlaylist | null;
}

export const heroPlaylistService = {
  // Get all hero playlists (Super Admin)
  async getAll(): Promise<HeroPlaylist[]> {
    const { data } = await axios.get('/hero-playlists');
    return data;
  },

  // Check if playlist is in hero
  async checkPlaylistInHero(playlistId: string): Promise<HeroCheckResult> {
    const { data } = await axios.get(`/hero-playlists/check/${playlistId}`);
    return data;
  },

  // Create new hero playlist (add playlist to hero)
  async create(heroPlaylist: CreateHeroPlaylistData): Promise<HeroPlaylist> {
    const { data } = await axios.post('/hero-playlists', heroPlaylist);
    return data;
  },

  // Update hero playlist
  async update(id: string, heroPlaylist: Partial<CreateHeroPlaylistData & { active: boolean }>): Promise<HeroPlaylist> {
    const { data } = await axios.put(`/hero-playlists/${id}`, heroPlaylist);
    return data;
  },

  // Delete hero playlist by ID
  async delete(id: string): Promise<{ message: string }> {
    const { data } = await axios.delete(`/hero-playlists/${id}`);
    return data;
  },

  // Remove playlist from hero by playlist ID
  async removeByPlaylistId(playlistId: string): Promise<{ message: string }> {
    const { data } = await axios.delete(`/hero-playlists/playlist/${playlistId}`);
    return data;
  },

  // Update hero playlist order
  async updateOrder(id: string, order: number): Promise<{ message: string; order: number }> {
    const { data } = await axios.patch(`/hero-playlists/${id}/order`, { order });
    return data;
  }
};
